export default {
      id: "arrow-right-usage",
      viewBox: "0 0 12 20",
      url: __webpack_public_path__ + "../../sprite.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }